import { useContext } from 'react';
import { SelectedStylepackContext } from './stylepack-context';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import { stylePackBannerImages } from './stylepack-resources';
// TODO pull in when can pull from greenroom's api
// import LoadStylepackThemes from '@/connection/greenroom/load-stylepack-themes';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import classNames from 'classnames';
import styles from './stylepacks.module.css';
import { Link } from 'react-router-dom';
import Chip from '@styles/design-system/components/chips/chip';

// greenroom images need this replacement to work
// https://greenroom-static-assets.greenroom-dev.brandlive.cloud/title_templates/stock_images/ (default image filename)

export default function StylepackHeader() {
  const stylepack = useContext(SelectedStylepackContext).stylepack;

  // TODO pull in colors from theme when greenroom api endpoint exists
  // useEffect(() => {
  //   if (stylepack) {
  //     LoadStylepackThemes({ channel: 0, stylepack: 'all' }).then(console.log).catch(console.error);
  //   }
  // }, [stylepack]);

  return (
    <Container
      backgroundImage={stylePackBannerImages[stylepack.stylePack]}
      width="100%"
      className={classNames('flex flex-column', styles.header)}
      padding="40px"
      borderRadius="12px"
      gap="16px"
      hoverBackground="transparent"
      transitionDuration="0ms"
    >
      <Container className="flex ai-center jc-space-between" hoverBackground="transparent">
        <Text tag="h2" className="H2">
          {stylepack.name}
        </Text>
        <Link to="./browse" relative="path">
          <Button designSize="large" design="LocalBttnSecHalfTransp" className="flex gap-8 ai-center">
            <Icon name={ICONS.REDO_ALT} size={12} />
            <Text className="L1">Switch Stylepack</Text>
          </Button>
        </Link>
      </Container>
      <Container height="48px">{/* Theme colors cannot be loaded due to greenroom api bug - TODO */}</Container>
      <Container className="flex gap-8">
        <Chip type="filter-tab" label="Countdowns" icon={ICONS.COUNTDOWNS} size={32} />
        <Chip type="filter-tab" label="Bookends" icon={ICONS.BOOKENDS} size={32} />
        <Chip type="filter-tab" label="Walkups" icon={ICONS.WALKUPS} size={32} />
        <Chip type="filter-tab" label="Lowers" icon={ICONS.LOWERS} size={32} />
        <Chip type="filter-tab" label="Segments" icon={ICONS.SEGMENTS} size={32} />
      </Container>
    </Container>
  );
}
